/* eslint class-methods-use-this: "off" */
import GridUtils from "../GridUtils.js";
import GridRange from "../GridRange.js";
import KeyHandler from "../KeyHandler.js";
import { isEditableGridModel } from "../EditableGridModel.js";
class EditKeyHandler extends KeyHandler {
  onDown(event, grid) {
    if (GridUtils.isModifierKeyDown(event)) {
      return false;
    }
    var model = grid.props.model;
    var _grid$state = grid.state,
      cursorColumn = _grid$state.cursorColumn,
      cursorRow = _grid$state.cursorRow;
    if (cursorColumn == null || cursorRow == null || !isEditableGridModel(model)) {
      return false;
    }
    var modelColumn;
    var modelRow;
    try {
      modelColumn = grid.getModelColumn(cursorColumn);
      modelRow = grid.getModelRow(cursorRow);
    } catch (_unused) {
      return false;
    }
    if (!model.isEditableRange(GridRange.makeCell(modelColumn, modelRow))) {
      return false;
    }
    if (event.key.length === 1) {
      // If the renderer for this cell's restriction type preserves the existing
      // value on keystroke (e.g. a dropdown), open the editor without replacing.
      var cellInputRendererRegistry = grid.props.cellInputRendererRegistry;
      var restrictions = model.getColumnRestrictions(modelColumn);
      if (restrictions.length === 1) {
        var renderer = cellInputRendererRegistry === null || cellInputRendererRegistry === void 0 ? void 0 : cellInputRendererRegistry.get(restrictions[0].type);
        if ((renderer === null || renderer === void 0 ? void 0 : renderer.preservesExistingValue) === true) {
          grid.startEditing(cursorColumn, cursorRow);
          return true;
        }
      }
      grid.startEditing(cursorColumn, cursorRow, true, [1, 1], event.key);
      return true;
    }
    if (event.key === 'F2') {
      grid.startEditing(cursorColumn, cursorRow);
      return true;
    }
    if (event.key === 'Enter') {
      grid.startEditing(cursorColumn, cursorRow);
      return true;
    }
    if (event.key === 'Backspace') {
      grid.startEditing(cursorColumn, cursorRow, true, undefined, '');
      return true;
    }
    if (event.key === 'Delete') {
      grid.setValueForCell(cursorColumn, cursorRow, '');
      return true;
    }
    return false;
  }
}
export default EditKeyHandler;
//# sourceMappingURL=EditKeyHandler.js.map